import React, { useState } from 'react';
import './Faq.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Faq = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (faqId) => {
    setOpenFaq(openFaq === faqId ? null : faqId);
  };

  const faqItems = [
    {
      id: 1,
      question: "Je ne paie pas d'impôts — est-ce que le crédit d'impôt me concerne quand même ?",
      answer: "Oui, tout à fait. Le crédit d'impôt n'est pas réservé aux contribuables : même sans impôts à payer, l'État vous rembourse directement 50 % de vos dépenses par virement. C'est la grande différence avec une réduction d'impôt — vous récupérez la moitié dans tous les cas.",
    },
    {
      id: 2,
      question: "Concrètement, comment je récupère mes 50 % ?",
      answer: "Chaque année, je vous envoie une attestation fiscale qui récapitule le total de vos prestations. Il vous suffit de reporter ce montant sur votre déclaration de revenus. L'État se charge du reste : il déduit 50 % de votre impôt, ou vous verse directement la somme si vous n'êtes pas imposable.",
    },
    {
      id: 3,
      question: "Quels travaux de jardin ouvrent droit au crédit d'impôt ?",
      answer: "Tous mes services d'entretien courant sont éligibles : tonte de pelouse, taille de haies et d'arbustes, désherbage, débroussaillage et taille de petits arbres ou fruitiers. En revanche, les travaux de création de jardin et l'élagage lourd ne rentrent pas dans le dispositif.",
    },
    {
      id: 4,
      question: "Où intervenez-vous ?",
      answer: "Je suis basé à Magnagnac et je me déplace dans un rayon de 45 km. J'interviens notamment à Toulouse, Montauban, Villemur-sur-Tarn, Fronton, Grenade, Castelnau-d'Estrétefonds, Bouloc, Villaudric, Bessières, Saint-Sulpice-la-Pointe, Lavaur, Gaillac, Rabastens et dans toutes les communes aux alentours. Un doute sur votre secteur ? Contactez-moi, on s'arrange.",
    },
    {
      id: 5,
      question: "Peut-on prévoir un entretien régulier plutôt qu'une intervention ponctuelle ?",
      answer: "C'est même ce que je recommande. Je propose des passages réguliers adaptés à votre jardin et à vos habitudes — mensuel, bimensuel ou saisonnier. En plus d'un jardin toujours soigné, un suivi régulier vous permet de maximiser votre crédit d'impôt sur l'année.",
    },
    {
      id: 6,
      question: "Dois-je être là quand vous venez ?",
      answer: "Non, ce n'est pas nécessaire. On fait le point ensemble lors d'un premier rendez-vous pour que je comprenne bien vos attentes. Ensuite, je peux travailler en votre absence tant que l'accès au jardin est possible. Je vous envoie un message après chaque passage pour vous tenir au courant.",
    },
    {
      id: 7,
      question: "Combien de temps faut-il attendre avant une première intervention ?",
      answer: "En règle générale, je peux planifier une première visite sous une à deux semaines. Pendant les périodes chargées — printemps et automne notamment — les délais peuvent être un peu plus longs. N'hésitez pas à me contacter pour qu'on trouve un créneau qui vous convient.",
    },
  ];

  return (
    <section id="infos" className="faq-section">
      <div className="faq-block">
        <div className="faq-container">
          <div className="faq-header">
            <h2>Foire aux questions</h2>
            <p>Tout ce que vous devez savoir sur l'entretien de jardin et le dispositif Services à la Personne.</p>
          </div>

          <div className="faq-list">
            {faqItems.map((item) => (
              <div key={item.id} className={`faq-item ${openFaq === item.id ? 'active' : ''}`}>
                <button className="faq-question" onClick={() => toggleFaq(item.id)}>
                  <span>{item.question}</span>
                  {openFaq === item.id ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                <div className={`faq-answer ${openFaq === item.id ? 'open' : ''}`}>
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
